import { DropShadowName } from 'widgets/ImageWidget/ImageWidget.types';

import { DROP_SHADOW_CONFIG } from './ShadowOptions.config';

/**
 * Determines the appropriate shadow filter based on optimization conditions.
 *
 * @param {boolean} optimize - Whether or not to optimize the shadow filter.
 * @param {DropShadowName} appliedDropShadowName - The name of the applied drop shadow.
 * @param {number} dropShadowIntensity - The intensity of the drop shadow.
 *
 * @returns {string} The computed shadow filter or an empty string if optimized.
 */
export const getOptimizedShadowFilter = (
  optimize: boolean,
  appliedDropShadowName: DropShadowName,
  dropShadowIntensity: number,
): string => {
  if (
    optimize &&
    (appliedDropShadowName === 'None' || appliedDropShadowName === 'Spread' || dropShadowIntensity < 85)
  ) {
    return '';
  }
  return DROP_SHADOW_CONFIG[appliedDropShadowName](dropShadowIntensity);
};
